<app-progress-bars></app-progress-bars>
<div class="app-need-update" *ngIf="appUpdatedNeedReload">
  <div class="app-need-update__message">
    The application's API has been updated. Please refresh the page to work with the latest version.
  </div>
</div>
<div class="app-version" *ngIf="enableBottomBar">
  <span class="statusbar__version">{{currentApplicationVersion}} ({{api_v}})</span>

  <ng-container *ngIf="systemStats$ | async as sysStats">
    <!-- Buttons, not spans: keyboard focus and screen-reader semantics come
         free, and the panel opens on focus as well as hover. -->
    <button type="button" class="statusbar__item"
            [class.is-warn]="sysStats.warn"
            [class.is-critical]="sysStats.critical"
            [attr.aria-expanded]="openPanel === 'system'"
            aria-label="Server storage and memory"
            (mouseenter)="showPanel('system')" (mouseleave)="hidePanel('system')"
            (focus)="showPanel('system')" (blur)="hidePanel('system')"
            (keydown.escape)="hidePanel('system')">
      <span class="statusbar__label">Disk</span>
      <span class="statusbar__value">{{sysStats.disk.pct}}%</span>
    </button>

    <button type="button" class="statusbar__item" *ngIf="sysStats.gmcLabel"
            [attr.aria-expanded]="openPanel === 'system'"
            aria-label="Products eligible for Google Merchant Center"
            (mouseenter)="showPanel('system')" (mouseleave)="hidePanel('system')"
            (focus)="showPanel('system')" (blur)="hidePanel('system')"
            (keydown.escape)="hidePanel('system')">
      <span class="statusbar__label">GMC</span>
      <span class="statusbar__value">{{sysStats.gmcLabel}}</span>
    </button>

    <div class="statuspanel" *ngIf="openPanel === 'system'" role="tooltip">
      <div class="statuspanel__section">
        <div class="statuspanel__head">
          <span class="statuspanel__title">Disk</span>
          <span class="statuspanel__pct" [ngClass]="meterState(sysStats.disk.pct)">{{sysStats.disk.pct}}%</span>
        </div>
        <div class="statuspanel__meter">
          <div class="statuspanel__meter-fill" [ngClass]="meterState(sysStats.disk.pct)"
               [style.width.%]="sysStats.disk.pct"></div>
        </div>
        <dl class="statuspanel__rows">
          <div><dt>Used</dt><dd>{{sysStats.disk.used}}</dd></div>
          <div><dt>Free</dt><dd>{{sysStats.disk.free}}</dd></div>
          <div><dt>Total</dt><dd>{{sysStats.disk.total}}</dd></div>
          <div *ngIf="sysStats.disk.uploads">
            <dt>Uploads</dt><dd>{{sysStats.disk.uploads}} <em>{{sysStats.disk.uploadFiles}} files</em></dd>
          </div>
        </dl>
      </div>

      <div class="statuspanel__section">
        <div class="statuspanel__head">
          <span class="statuspanel__title">Memory</span>
          <span class="statuspanel__pct" [ngClass]="meterState(sysStats.memory.pct)">{{sysStats.memory.pct}}%</span>
        </div>
        <div class="statuspanel__meter">
          <div class="statuspanel__meter-fill" [ngClass]="meterState(sysStats.memory.pct)"
               [style.width.%]="sysStats.memory.pct"></div>
        </div>
        <dl class="statuspanel__rows">
          <div><dt>Used</dt><dd>{{sysStats.memory.used}}</dd></div>
          <div><dt>Available</dt><dd>{{sysStats.memory.available}}</dd></div>
          <div><dt>Total</dt><dd>{{sysStats.memory.total}}</dd></div>
        </dl>
        <div class="statuspanel__chips" *ngIf="sysStats.memory.services.length">
          <span class="statuspanel__chip" *ngFor="let svc of sysStats.memory.services">
            {{svc.name}} <strong>{{svc.value}}</strong>
          </span>
        </div>
      </div>

      <div class="statuspanel__section" *ngIf="sysStats.gmc">
        <div class="statuspanel__head">
          <span class="statuspanel__title">Google Merchant Center</span>
        </div>
        <dl class="statuspanel__rows">
          <div><dt>BlackHawk</dt><dd>{{sysStats.gmc.bhs}}</dd></div>
          <div><dt>Midwest</dt><dd>{{sysStats.gmc.mws}}</dd></div>
          <div><dt>Catalogue</dt><dd>{{sysStats.gmc.total}} <em>{{sysStats.gmc.share}} eligible</em></dd></div>
        </dl>
        <ng-container *ngIf="gmcHistory">
          <div class="sparkline" *ngIf="!gmcHistory.collecting">
            <svg class="sparkline__svg" [attr.viewBox]="'0 0 ' + gmcHistory.width + ' ' + gmcHistory.height"
                 preserveAspectRatio="none" aria-hidden="true" focusable="false">
              <path class="sparkline__area" [attr.d]="gmcHistory.area"></path>
              <path class="sparkline__line" [attr.d]="gmcHistory.line"></path>
            </svg>
            <!-- The endpoint sits outside the stretched SVG so it stays round;
                 preserveAspectRatio="none" would squash a circle drawn inside. -->
            <span class="sparkline__tip"
                  [style.left.%]="100"
                  [style.top.%]="(gmcHistory.lastY / gmcHistory.height) * 100"></span>
          </div>
          <dl class="statuspanel__rows" *ngIf="!gmcHistory.collecting">
            <div>
              <dt>{{gmcHistory.days}}-day</dt>
              <dd>
                {{gmcHistory.high}} high · {{gmcHistory.low}} low
                <em *ngIf="gmcHistory.change"
                    [class.is-up]="gmcHistory.changeUp"
                    [class.is-down]="gmcHistory.changeDown">{{gmcHistory.change}}</em>
              </dd>
            </div>
            <div>
              <dt>All time</dt>
              <dd>{{gmcHistory.allTimeHigh}} high <em>{{gmcHistory.allTimeLow}} low</em></dd>
            </div>
          </dl>
          <p class="statuspanel__note" *ngIf="gmcHistory.collecting">
            Collecting history — a trend appears after a second day of data.
          </p>
        </ng-container>
        <p class="statuspanel__note">Recounted every 30 minutes · last {{sysStats.gmc.measured}}</p>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="presence$ | async as presence">
    <button type="button" class="statusbar__item"
            [class.is-active]="presence.highlight"
            [attr.aria-expanded]="openPanel === 'presence'"
            aria-label="Who is signed in"
            (mouseenter)="showPanel('presence')" (mouseleave)="hidePanel('presence')"
            (focus)="showPanel('presence')" (blur)="hidePanel('presence')"
            (keydown.escape)="hidePanel('presence')">
      <span class="statusbar__label">Team</span>
      <span class="statusbar__value">{{presence.label}}</span>
    </button>

    <div class="statuspanel statuspanel--people" *ngIf="openPanel === 'presence'" role="tooltip">
      <div class="statuspanel__section">
        <div class="statuspanel__head">
          <span class="statuspanel__title">{{presence.heading}}</span>
        </div>
        <p class="statuspanel__note statuspanel__note--top">{{presence.subheading}}</p>
        <ul class="peoplelist">
          <li class="peoplelist__row" *ngFor="let person of presence.rows"
              [class.is-working]="person.working">
            <span class="peoplelist__dot" aria-hidden="true"></span>
            <span class="peoplelist__name">{{person.name}}</span>
            <span class="peoplelist__action">{{person.action}}</span>
            <span class="peoplelist__when">{{person.when}}</span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>
  <button *ngIf="(user$ | async)?.access.level === 1" (click)="expressionBuilderDialog()">Expression Builder</button>
  <button style="opacity: 0;" (click)="test()">test</button>
</div>
<div class="header-content" *ngIf="ready">
  <div *ngIf="currentUrl === '/user' || currentUrl === '/admin' || currentUrl === '/grid/collections' || currentUrl === '/delete' || currentUrl === '/uploads'" class="user-menu-area">
    <button class="toolbar-btn" (click)="backToGrid()" mat-raised-button color="primary">Back to Grid</button>
  </div>
  <div *ngIf="currentUrl === '/delete'" class="user-menu-area">
    <button class="delete-btn btn-warn-flat" [matMenuTriggerFor]="deleteMenu" mat-raised-button color="warn" *ngIf="user$ | async as user" [disabled]="user.access.level === 3"><mat-icon>delete</mat-icon> Delete</button>
    <mat-menu class="primary" #deleteMenu="matMenu">
      <button (click)="deleteSelectedProducts()" [disabled]="stageSelectedItemsCount === 0" mat-menu-item>Selected Items <span *ngIf="stageSelectedItemsCount"> ({{stageSelectedItemsCount}})</span></button>
      <button (click)="deleteFilteredProducts()" [disabled]="stageFilterIsActive === false" mat-menu-item>Filtered Items</button>
    </mat-menu>
  </div>
  <!--Staging-->
  <div class="header-buttons" *ngIf="currentTable?.name === 'Staging' || currentTable?.name === 'Duplicates'">
    <div class="table-view-toggle" role="group" aria-label="Table View">
      <button *ngFor="let table of tableSelectorValue"
              type="button"
              class="table-view-toggle__segment"
              [class.active]="tableSelector.value === table.id"
              [class.icon-only]="table.name === 'Change History'"
              [attr.aria-pressed]="tableSelector.value === table.id"
              [matTooltip]="table.name === 'Change History' ? table.name : ''"
              (click)="selectTableView(table)">
        <mat-icon *ngIf="table.name === 'Change History'; else segmentLabel">history</mat-icon>
        <ng-template #segmentLabel>{{table.name}}</ng-template>
      </button>
    </div>

    <button class="bulk-btn btn-warn-flat" [matMenuTriggerFor]="bulkMenu" mat-raised-button color="warn" *ngIf="user$ | async as user"><mat-icon>edit</mat-icon> Bulk Edit</button>
    <mat-menu class="primary" #bulkMenu="matMenu">
      <button (click)="bulkEditSelectedDialog()" [disabled]="stageSelectedItemsCount === 0" mat-menu-item>Selected Items <span *ngIf="stageSelectedItemsCount"> ({{stageSelectedItemsCount}})</span></button>
      <button (click)="bulkEditFilterDialog()" [disabled]="stageFilterIsActive === false" mat-menu-item>Filtered Items</button>
    </mat-menu>

    <button class="changes-btn toolbar-btn" (click)="viewAllChangesProductOnStage()" [disabled]="stageModifiedProductsCounter === 0" mat-raised-button color="primary"><mat-icon>update</mat-icon> View modified products<span *ngIf="stageModifiedProductsCounter"> ({{stageModifiedProductsCounter}})</span></button>&nbsp;
    <button class="btn-go" *ngIf="(user$ | async)?.access.level === 1" [disabled]="!(historyChangesCounter$ | async) || pushToProductionPending" (click)="pushAllAndSync()" mat-raised-button color="primary">{{pushToProductionPending ? ('Syncing... ' + (megaBtnPercent !== null ? megaBtnPercent + '%' : '')) : 'Update & Sync'}}</button>
    <button matTooltip="Clear All Filters" [disabled]="stageFilterIsActive === false" (click)="clearAllFilters('stage')" mat-icon-button>
      <mat-icon>layers_clear</mat-icon>
    </button>
    <button (click)="resetColumnState('stage')" matTooltip="Reset Column State" mat-icon-button>
      <mat-icon>view_column</mat-icon>
    </button>
    <button [matMenuTriggerFor]="collectionsMenu" matTooltip="Collections" mat-icon-button>
      <mat-icon>list</mat-icon>
    </button>
    <mat-menu class="primary" #collectionsMenu="matMenu">
      <button (click)="goToCollections()" mat-menu-item>Show Collections</button>
      <button (click)="showReadyProducts()" mat-menu-item>Show ready products for AI</button>
      <mat-divider></mat-divider>
      <button (click)="regenerateSelectedCollections()" mat-menu-item>Get AI Structure for <b>selected</b> items</button>
      <button (click)="regenerateFilteredCollections()" mat-menu-item>Get AI Structure for <b>filtered</b> items</button>
      <mat-divider></mat-divider>
      <button (click)="getAiTitleForFiltered()" mat-menu-item>Get AI Title for <b>filtered</b> items</button>
    </mat-menu>

<!--    <button [matMenuTriggerFor]="collectionsMenu" mat-icon-button><mat-icon>refresh</mat-icon></button>-->
<!--    <mat-menu class="primary" #collectionsMenu="matMenu">-->
<!--      <button (click)="startSelectedGptFineTuneModel()" mat-menu-item>StartSelectedGptFineTuneModel</button>-->
<!--      <button (click)="regenerateCollections()" mat-menu-item>Regenerate Collections</button>-->
<!--    </mat-menu>-->
    <button *ngIf="environment.staging" [matMenuTriggerFor]="headerInfoMenu" class="header_info_icon" matTooltip="Info" mat-mini-fab color="outline">
      <mat-icon>info_outline</mat-icon>
      <span class="title-ai-conflict-counter">{{title_aiConflictCounter}}</span>
    </button>
    <mat-menu class="primary" #headerInfoMenu="matMenu">
      <button (click)="showTitleAiConflictProducts()" mat-menu-item><b>{{title_aiConflictCounter}}</b> modified products conflict with Title AI. Title will not be updated.</button>
      <button (click)="showReadyTitleAiProducts()" mat-menu-item>showReadyTitleAiProducts</button>
      <mat-divider></mat-divider>
    </mat-menu>
  </div>

  <!--Production-->
  <div class="header-buttons" *ngIf="currentTable?.name === 'Production'">
    <div class="table-view-toggle" role="group" aria-label="Table View">
      <button *ngFor="let table of tableSelectorValue"
              type="button"
              class="table-view-toggle__segment"
              [class.active]="tableSelector.value === table.id"
              [class.icon-only]="table.name === 'Change History'"
              [attr.aria-pressed]="tableSelector.value === table.id"
              [matTooltip]="table.name === 'Change History' ? table.name : ''"
              (click)="selectTableView(table)">
        <mat-icon *ngIf="table.name === 'Change History'; else segmentLabel">history</mat-icon>
        <ng-template #segmentLabel>{{table.name}}</ng-template>
      </button>
    </div>

    <button class="btn-go" *ngIf="user$ | async as user" (click)="handleKey($event)" [disabled]="user.access.level === 3" [matMenuTriggerFor]="menu" mat-raised-button color="primary">Shopify Sync</button>&nbsp;
    <mat-menu class="primary" #menu="matMenu">
      <button (click)="forceCreateFeedSelected()" [disabled]="productionSelectedItemsCount === 0" mat-menu-item>
        Selected Items <span *ngIf="productionSelectedItemsCount"> ({{productionSelectedItemsCount}})</span>
      </button>
      <button (click)="forceCreateFeedFiltered()" [disabled]="productionFilterIsActive === false" mat-menu-item>Filtered Items</button>
      <button (click)="createFeedChanged()" [disabled]="productionNotSyncItemCount === 0" mat-menu-item>Changed Items</button>
      <mat-divider></mat-divider>
      <button (click)="forceCreateFeedSelected()"  mat-menu-item>⚡️ Force Sync Selected Items️</button>
      <button (click)="forceCreateFeedFiltered()" [disabled]="productionFilterIsActive === false" mat-menu-item>⚡️ Force Sync Filtered Items️</button>
    </mat-menu>

    <button class="toolbar-btn" *ngIf="user$ | async as user" [disabled]="user.access.level === 3" [matMenuTriggerFor]="gmcmenu" mat-raised-button color="primary">GMC</button>&nbsp;
    <mat-menu class="primary" #gmcmenu="matMenu">
      <button (click)="gmcOpenBHSFeed()" mat-menu-item>Open BHS Feed</button>
      <button (click)="gmcOpenMWSFeed()" mat-menu-item>Open MWS Feed</button>
      <mat-divider></mat-divider>
      <button (click)="gmcBHSFeed()" mat-menu-item>Update Feeds</button>
<!--      <button (click)="gmcMWSFeed()" mat-menu-item>Update MWS Feed</button>-->
    </mat-menu>
<!--    // delete products-->
<!--    <button *ngIf="user$ | async as user" matTooltip="{{deleteTooltip}}" (click)="deleteProducts()" [disabled]="user.access.level === 3" class="close-btn" mat-icon-button>-->
<!--      <mat-icon>delete</mat-icon>-->
<!--    </button>-->
<!--    <button *ngIf="user$ | async as user" [disabled]="user.access.level === 3" [matMenuTriggerFor]="asmmenu" mat-raised-button color="primary">ASM</button>&nbsp;-->
<!--    <mat-menu class="primary" #asmmenu="matMenu">-->
<!--      <button (click)="asmExportSelected()" [disabled]="productionSelectedItemsCount === 0" mat-menu-item>Export Selected Items <span *ngIf="productionSelectedItemsCount"> ({{productionSelectedItemsCount}})</span></button>-->
<!--      <button (click)="asmExportFiltered()" mat-menu-item>Export Filtered Items</button>-->
<!--    </mat-menu>-->

    <button class="toolbar-btn" (click)="viewAllChangesProductOnProduction()" mat-raised-button color="primary">View modified products<span *ngIf="productionModifiedProductsCounter"> ({{productionModifiedProductsCounter}})</span></button>&nbsp;

    <button matTooltip="Clear All Filters" [disabled]="productionFilterIsActive === false" (click)="clearAllFilters('production')" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
      <mat-icon>layers_clear</mat-icon>
    </button>
    <button (click)="resetColumnState('production')" matTooltip="Reset Column State" mat-icon-button>
      <mat-icon>view_column</mat-icon>
    </button>
  </div>

  <!--Changes-->
  <div class="header-buttons" *ngIf="currentTable?.name === 'Changes'">
    <div class="table-view-toggle" role="group" aria-label="Table View">
      <button *ngFor="let table of tableSelectorValue"
              type="button"
              class="table-view-toggle__segment"
              [class.active]="tableSelector.value === table.id"
              [class.icon-only]="table.name === 'Change History'"
              [attr.aria-pressed]="tableSelector.value === table.id"
              [matTooltip]="table.name === 'Change History' ? table.name : ''"
              (click)="selectTableView(table)">
        <mat-icon *ngIf="table.name === 'Change History'; else segmentLabel">history</mat-icon>
        <ng-template #segmentLabel>{{table.name}}</ng-template>
      </button>
    </div>

    <button [disabled]="!(historyConflictCounter$ | async)" (click)="showConflictRecords()" mat-raised-button color="warn">Conflicts <span *ngIf="historyConflictCounter$ | async">({{historyConflictCounter$ | async}})</span></button>
    <button *ngIf="user$ | async as user" [disabled]="approveAllChangesPending || !(historyChangesCounter$ | async) || user.access.level === 3" (click)="approveAllChanges()" mat-raised-button color="warn">Approve all changes <span *ngIf="historyChangesCounter$ | async">({{historyChangesCounter$ | async}})</span></button>
    <button *ngIf="user$ | async as user" [disabled]="disapproveAllChangesPending || !(disapproveCounter$ | async) || user.access.level === 3" (click)="disapproveAllChanges()" mat-raised-button color="warn">Disapprove all changes <span *ngIf="disapproveCounter$ | async">({{disapproveCounter$ | async}})</span></button>
    <button class="btn-go" *ngIf="user$ | async as user" [disabled]="!(historyApprovedCounter$ | async) || user.access.level === 3 || pushToProductionPending" (click)="pushToProduction()" mat-raised-button color="primary">{{pushToProductionPending ? 'Pushing...' : 'Push to production Database'}} <span *ngIf="(historyApprovedCounter$ | async) && user.access.level !== 3 && !pushToProductionPending">({{historyApprovedCounter$ | async}})</span></button>

    <button matTooltip="Clear All Filters" [disabled]="changesFilterIsActive === false" (click)="clearAllFilters('changes')" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
      <mat-icon>layers_clear</mat-icon>
    </button>
    <button (click)="resetColumnState('changes')" matTooltip="Reset Column State" mat-icon-button>
      <mat-icon>view_column</mat-icon>
    </button>
  </div>

  <!--Change History-->
  <div class="header-buttons" *ngIf="currentTable?.name === 'Change History'">
    <div class="table-view-toggle" role="group" aria-label="Table View">
      <button *ngFor="let table of tableSelectorValue"
              type="button"
              class="table-view-toggle__segment"
              [class.active]="tableSelector.value === table.id"
              [class.icon-only]="table.name === 'Change History'"
              [attr.aria-pressed]="tableSelector.value === table.id"
              [matTooltip]="table.name === 'Change History' ? table.name : ''"
              (click)="selectTableView(table)">
        <mat-icon *ngIf="table.name === 'Change History'; else segmentLabel">history</mat-icon>
        <ng-template #segmentLabel>{{table.name}}</ng-template>
      </button>
    </div>

    <button matTooltip="Clear All Filters" [disabled]="historyFilterIsActive === false" (click)="clearAllFilters('')" mat-icon-button aria-label="Example icon button with a vertical three dot icon">
      <mat-icon>layers_clear</mat-icon>
    </button>
    <button (click)="resetColumnState('')" matTooltip="Reset Column State" mat-icon-button>
      <mat-icon>view_column</mat-icon>
    </button>
  </div>

  <!--header-right-area-->
  <div class="header-right-area">
    <div class="export-import-area">
      <button (click)="importDialog()" *ngIf="currentTable?.name === 'Staging'" matTooltip="Import" mat-mini-fab color="basic">
        <mat-icon>file_download</mat-icon>
      </button>
      &nbsp;
      <div *ngIf="currentTable?.name === 'Staging' || currentTable?.name === 'Production' || currentTable?.name === 'Changes' || currentTable?.name === 'Change History'">
        <button *ngIf="user$ | async as user" [matMenuTriggerFor]="exportMenu" matTooltip="Export" mat-mini-fab color="basic">
          <mat-icon>file_upload</mat-icon>
        </button>
      </div>
      <mat-menu class="primary" #exportMenu="matMenu">
        <button (click)="selectedExportDialog()" [disabled]="stageSelectedItemsCount === 0 && productionSelectedItemsCount === 0 && changesSelectedItemsCount === 0 && historySelectedItemsCount === 0" mat-menu-item>All Selected Items<span *ngIf="stageSelectedItemsCount + productionSelectedItemsCount + changesSelectedItemsCount + historySelectedItemsCount"> ({{stageSelectedItemsCount + productionSelectedItemsCount + changesSelectedItemsCount + historySelectedItemsCount}})</span></button>
        <button (click)="filteredExportDialog()" mat-menu-item>All Filtered Items</button>
        <mat-divider></mat-divider>
        <button (click)="scheduleFilteredExportDialog()" [disabled]="!stageFilterIsActive && !productionFilterIsActive && !changesFilterIsActive" mat-menu-item>
          <mat-icon>schedule</mat-icon>
          Schedule Filtered Export
        </button>
      </mat-menu>
    </div>

    <div class="user-area" *ngIf="user$ | async as user">
      <div class="user-w" [matMenuTriggerFor]="userMenu">
        <div class="user-avatar">
          <img *ngIf="user.avatar" [src]="user.avatar" [alt]="user.name">
          <span *ngIf="!user.avatar" class="user-initials">{{user.name?.charAt(0) || 'U'}}</span>
        </div>
        <div>
          <div class="user-name">{{user.name}}</div>
          <div class="user-role">{{user.access.group}}</div>
        </div>
      </div>

      <mat-menu #userMenu="matMenu">
        <button (click)="adminSettings()" *ngIf="showAdminSettings" mat-menu-item>
          <mat-icon>build</mat-icon>
          <span>App Settings</span>
        </button>
        <button (click)="goToDelete()" *ngIf="showAdminSettings" mat-menu-item>
          <mat-icon>delete</mat-icon>
          <span>Deletions Database</span>
        </button>
        <button (click)="goToUploads()" mat-menu-item>
          <mat-icon>cloud_download</mat-icon>
          <span>Export Downloads</span>
        </button>
        <button (click)="userSettings()" mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>User Settings</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="restartApi()" mat-menu-item>
          <mat-icon>autorenew</mat-icon>
          <span>Restart</span>
        </button>
        <mat-divider></mat-divider>
        <button (click)="logout()" mat-menu-item>
          <mat-icon>logout</mat-icon>
          <span>Logout</span>
        </button>
      </mat-menu>
    </div>

  </div>
</div>
